import { createApp } from 'vue'
import App from './App.vue'
import { MotionPlugin } from 'motion-v'
import './css/responsive.css'
import { API_BASE_URL } from './config/api'

// 检查落地页设置
async function checkLandingPage() {
  try {
    const domain = window.location.hostname
    const res = await fetch(`${API_BASE_URL}/api/landing/check?domain=${encodeURIComponent(domain)}`)
    const data = await res.json()

    if (data.code === 0 && data.hasLanding && data.landingFile) {
      // 有落地页设置，跳转到落地页
      window.location.href = `/landing/${data.landingFile}`
      return true
    }
  } catch (e) {
    console.log('检查落地页失败', e)
  }
  return false
}

// 先检查落地页，没有才加载Vue应用
checkLandingPage().then(hasLanding => {
  if (!hasLanding) {
    // 控制台彩蛋
    console.log(`
%c  bbbbbbbbb        ccccccccc
  b        bb     cc
  b         b    c
  b        bb    c
  bbbbbbbbb      c
  b        bb    c
  b         b    c
  b         b     cc
  b        bb      ccccccccc
  bbbbbbbbb
`, 'color: #4CAF50; font-family: monospace; font-size: 14px;')

    console.log('%c 白菜台 - By @lingshentop ', 'background: linear-gradient(90deg, #667eea, #764ba2); color: white; padding: 8px 16px; border-radius: 4px; font-size: 14px; font-weight: bold;')

    const app = createApp(App)

    app.use(MotionPlugin, {
      presets: {
        'fade-up': {
          initial: { opacity: 0, y: 24 },
          animate: { opacity: 1, y: 0 },
          transition: { duration: 0.4, ease: 'easeOut' }
        },
        'fade-down': {
          initial: { opacity: 0, y: -24 },
          animate: { opacity: 1, y: 0 },
          transition: { duration: 0.4, ease: 'easeOut' }
        },
        'fade-in': {
          initial: { opacity: 0 },
          animate: { opacity: 1 },
          transition: { duration: 0.35 }
        },
        'scale-in': {
          initial: { opacity: 0, scale: 0.92 },
          animate: { opacity: 1, scale: 1 },
          transition: { duration: 0.3, ease: 'easeOut' }
        }
      }
    })

    app.mount('#app')

    // 注册 Service Worker（用于 PWA 推送通知）
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js')
        .then(function(registration) {
          console.log('Service Worker 注册成功, scope:', registration.scope)
        })
        .catch(function(error) {
          console.error('Service Worker 注册失败:', error)
        })

      // 监听 Service Worker 请求免打扰列表
      navigator.serviceWorker.addEventListener('message', function(event) {
        if (event.data && event.data.type === 'getMutedSessions') {
          // 从 localStorage 读取免打扰列表，遍历所有可能的 key
          var mutedList = []
          try {
            for (var i = 0; i < localStorage.length; i++) {
              var key = localStorage.key(i)
              if (key && key.startsWith('mutedSessions_')) {
                var list = JSON.parse(localStorage.getItem(key))
                if (Array.isArray(list)) {
                  mutedList = mutedList.concat(list)
                }
              }
            }
          } catch (e) {
            console.log('读取免打扰列表失败:', e)
          }
          event.ports[0].postMessage(mutedList)
        }
      })
    }
  }
})
